// Task Card Icons
// Gold (#F2CE88, #7A664E) for hover, Gray (#9E9E9E, #545454) for default

// Menu action icons
export const EditIconDefault = () => (
  <svg width="14" height="14" viewBox="0 0 32 32" fill="none">
    <path d="M22.5 4.5L27.5 9.5L12 25L7 20L22.5 4.5Z" fill="var(--app-text-secondary)" />
    <path d="M12 25L7 20L4 28L12 25Z" fill="var(--app-text-muted)" />
    <rect x="6" y="24" width="4" height="4" rx="1" fill="var(--app-text-secondary)" />
  </svg>
)

export const EditIconHover = () => (
  <svg width="14" height="14" viewBox="0 0 32 32" fill="none">
    <path d="M22.5 4.5L27.5 9.5L12 25L7 20L22.5 4.5Z" fill="var(--app-accent-hover)" />
    <path d="M12 25L7 20L4 28L12 25Z" fill="var(--app-accent-text)" />
    <rect x="6" y="24" width="4" height="4" rx="1" fill="var(--app-accent-hover)" />
  </svg>
)

export const DuplicateIconDefault = () => (
  <svg width="14" height="14" viewBox="0 0 32 32" fill="none">
    <rect x="10" y="10" width="16" height="16" rx="3" fill="var(--app-text-muted)" />
    <path
      d="M8 22V10C8 7.79086 9.79086 6 12 6H22"
      stroke="var(--app-text-secondary)"
      strokeWidth="4"
      strokeLinecap="round"
    />
  </svg>
)

export const DuplicateIconHover = () => (
  <svg width="14" height="14" viewBox="0 0 32 32" fill="none">
    <rect x="10" y="10" width="16" height="16" rx="3" fill="var(--app-accent-text)" />
    <path
      d="M8 22V10C8 7.79086 9.79086 6 12 6H22"
      stroke="var(--app-accent-hover)"
      strokeWidth="4"
      strokeLinecap="round"
    />
  </svg>
)

export const ArchiveIconDefault = () => (
  <svg width="14" height="14" viewBox="0 0 32 32" fill="none">
    <rect x="4" y="12" width="24" height="16" rx="3" fill="var(--app-text-secondary)" />
    <rect x="6" y="8" width="20" height="4" rx="1" fill="var(--app-text-muted)" />
    <rect x="12" y="16" width="8" height="4" rx="1" fill="var(--app-text-muted)" />
  </svg>
)

export const ArchiveIconHover = () => (
  <svg width="14" height="14" viewBox="0 0 32 32" fill="none">
    <rect x="4" y="12" width="24" height="16" rx="3" fill="var(--app-accent-hover)" />
    <rect x="6" y="8" width="20" height="4" rx="1" fill="var(--app-accent-text)" />
    <rect x="12" y="16" width="8" height="4" rx="1" fill="var(--app-accent-text)" />
  </svg>
)

export const InfoIconDefault = () => (
  <svg width="14" height="14" viewBox="0 0 32 32" fill="none">
    <circle cx="16" cy="16" r="12" fill="var(--app-text-secondary)" />
    <rect x="14.5" y="14" width="3" height="8" rx="1.5" fill="var(--app-text-muted)" />
    <circle cx="16" cy="10" r="2" fill="var(--app-text-muted)" />
  </svg>
)

export const InfoIconHover = () => (
  <svg width="14" height="14" viewBox="0 0 32 32" fill="none">
    <circle cx="16" cy="16" r="12" fill="var(--app-accent-hover)" />
    <rect x="14.5" y="14" width="3" height="8" rx="1.5" fill="var(--app-accent-text)" />
    <circle cx="16" cy="10" r="2" fill="var(--app-accent-text)" />
  </svg>
)

export const DeleteIconDefault = () => (
  <svg width="14" height="14" viewBox="0 0 32 32" fill="none">
    <rect x="8" y="10" width="16" height="18" rx="2" fill="var(--app-text-secondary)" />
    <rect x="6" y="6" width="20" height="4" rx="1" fill="var(--app-text-muted)" />
    <path
      d="M12 6V4C12 3.44772 12.4477 3 13 3H19C19.5523 3 20 3.44772 20 4V6"
      stroke="var(--app-text-secondary)"
      strokeWidth="2"
    />
    <path d="M12 14V24" stroke="var(--app-text-muted)" strokeWidth="2" strokeLinecap="round" />
    <path d="M16 14V24" stroke="var(--app-text-muted)" strokeWidth="2" strokeLinecap="round" />
    <path d="M20 14V24" stroke="var(--app-text-muted)" strokeWidth="2" strokeLinecap="round" />
  </svg>
)

export const DeleteIconHover = () => (
  <svg width="14" height="14" viewBox="0 0 32 32" fill="none">
    <rect x="8" y="10" width="16" height="18" rx="2" fill="var(--app-accent-hover)" />
    <rect x="6" y="6" width="20" height="4" rx="1" fill="var(--app-accent-text)" />
    <path
      d="M12 6V4C12 3.44772 12.4477 3 13 3H19C19.5523 3 20 3.44772 20 4V6"
      stroke="var(--app-accent-hover)"
      strokeWidth="2"
    />
    <path d="M12 14V24" stroke="var(--app-accent-text)" strokeWidth="2" strokeLinecap="round" />
    <path d="M16 14V24" stroke="var(--app-accent-text)" strokeWidth="2" strokeLinecap="round" />
    <path d="M20 14V24" stroke="var(--app-accent-text)" strokeWidth="2" strokeLinecap="round" />
  </svg>
)

// Task type icons
export const VideoCallIcon = () => (
  <svg width="16" height="16" viewBox="0 0 32 32" fill="none">
    <rect x="4" y="10" width="18" height="12" rx="2" fill="var(--app-accent-hover)" />
    <path d="M22 14L28 10V22L22 18V14Z" fill="var(--app-accent-text)" />
  </svg>
)

export const ConversationIcon = () => (
  <svg width="16" height="16" viewBox="0 0 32 32" fill="none">
    <circle cx="16" cy="16" r="10" fill="var(--app-accent-hover)" />
    <path
      d="M11 16C11 18.7614 13.2386 21 16 21C18.7614 21 21 18.7614 21 16"
      stroke="var(--app-accent-text)"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="12" cy="13" r="1.5" fill="var(--app-accent-text)" />
    <circle cx="20" cy="13" r="1.5" fill="var(--app-accent-text)" />
  </svg>
)

export const ChatTypeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 32 32" fill="none">
    <path
      d="M4 10C4 7.79086 5.79086 6 8 6H24C26.2091 6 28 7.79086 28 10V20C28 22.2091 26.2091 24 24 24H10L4 28V10Z"
      fill="var(--app-accent-hover)"
    />
    <rect x="8" y="11" width="10" height="2" rx="1" fill="var(--app-accent-text)" />
    <rect x="8" y="15" width="14" height="2" rx="1" fill="var(--app-accent-text)" />
    <rect x="8" y="19" width="6" height="2" rx="1" fill="var(--app-accent-text)" />
  </svg>
)

// Plus icon for Add New Task
export const PlusIcon = () => (
  <svg width="24" height="24" viewBox="0 0 32 32" fill="none">
    <circle
      cx="16"
      cy="16"
      r="10"
      stroke="var(--app-accent-hover)"
      strokeWidth="2"
      strokeDasharray="4 4"
    />
    <path d="M16 12V20" stroke="var(--app-accent-text)" strokeWidth="2" strokeLinecap="round" />
    <path d="M12 16H20" stroke="var(--app-accent-text)" strokeWidth="2" strokeLinecap="round" />
  </svg>
)
